<template>
    <div v-if="isOpen" class="modal fade show group-offer-modal" aria-labelledby="productGroupOfferTitle" style="display: block; background: #1c1d1c66">
        <div class="modal-dialog modal-dialog-centered modal-xl">
            <div class="modal-content">
                <div class="modal-header-bar">
                    <div class="d-flex justify-content-between align-items-center px-3 py-2">
                        <h1 class="modal-title mb-0">Bulk Offer Setup</h1>
                        <div class="d-flex align-items-center">
                            <div class="group-select-field me-2">
                                <v-select
                                    v-model="groupId"
                                    label="name"
                                    placeholder="Select Product Group"
                                    :options="productGroups"
                                    :reduce="item => item.id"
                                />
                            </div>
                            <button
                                @click="toggleModal"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <div class="table-responsive offer-table-wrap">
                    <table class="table offer-table">
                        <thead>
                            <tr>
                                <th style="min-width: 220px">Product</th>
                                <th style="min-width: 220px">Customer</th>
                                <th>UoM</th>
                                <th>Min. Order Qty</th>
                                <th>Slab Qty</th>
                                <th>Bonus Qty</th>
                                <th>Discount Amount</th>
                                <th>Discount Percentage</th>
                                <th>Offer Start Date</th>
                                <th>Offer End Date</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="global-row">
                                <td class="global-label">
                                    <span class="global-badge">Apply to all</span>
                                </td>
                                <td>
                                    <AsyncSelect
                                        placeholder="Select Customer"
                                        v-model="globalContact"
                                        :api-service="fetchContactProfiles"
                                        :format-label="formatPatientLabel"
                                        :option-selected="applyGlobalContact"
                                        :additional-query="customerQuery"
                                        label="name"
                                    />
                                </td>
                                <td class="text-center text-muted">-</td>
                                <td>
                                    <input v-model.trim="globalValues.min_order_qtn" @input="applyGlobalValue('min_order_qtn')" type="number" class="form-control text-center" :min="0">
                                </td>
                                <td>
                                    <input v-model.trim="globalValues.slab_qtn" @input="applyGlobalValue('slab_qtn')" type="number" class="form-control text-center" :min="0">
                                </td>
                                <td>
                                    <input v-model="globalValues.bonus_qty" @input="applyGlobalValue('bonus_qty')" type="number" class="form-control text-center" :min="0">
                                </td>
                                <td>
                                    <input v-model="globalValues.discount_amount" @input="applyGlobalValue('discount_amount')" type="number" class="form-control text-center" :min="0">
                                </td>
                                <td>
                                    <input v-model="globalValues.discount_percentage" @input="applyGlobalValue('discount_percentage')" type="number" class="form-control text-center" :min="0">
                                </td>
                                <td>
                                    <input v-model.trim="globalValues.offer_start_date" @input="applyGlobalValue('offer_start_date')" type="date" class="form-control text-center">
                                </td>
                                <td>
                                    <input v-model.trim="globalValues.offer_end_date" @input="applyGlobalValue('offer_end_date')" type="date" class="form-control text-center">
                                </td>
                                <td>
                                    <div :class="['status-dropdown', globalValues.status.toLowerCase()]">
                                        <select v-model="globalValues.status" @change="applyGlobalValue('status')" class="form-control text-center">
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                    </div>
                                </td>
                            </tr>
                            <tr v-for="(item, index) in items" :key="item.product_id">
                                <td class="product-name">{{ item.product_name }}</td>
                                <td>
                                    <AsyncSelect
                                        placeholder="Select Customer"
                                        v-model="item.customer"
                                        :api-service="fetchContactProfiles"
                                        :format-label="formatPatientLabel"
                                        :option-selected="() => onContactSelected(index)"
                                        :additional-query="customerQuery"
                                        label="name"
                                    />
                                </td>
                                <td class="text-center">{{ item.unit_of_measurment }}</td>
                                <td>
                                    <input v-model.trim="item.min_order_qtn" @input="markTouched(index, 'min_order_qtn')" type="number" class="form-control text-center" :min="0">
                                </td>
                                <td>
                                    <input v-model.trim="item.slab_qtn" @input="markTouched(index, 'slab_qtn')" type="number" class="form-control text-center" :min="0">
                                </td>
                                <td>
                                    <input v-model="item.bonus_qty" @input="markTouched(index, 'bonus_qty')" type="number" class="form-control text-center" :min="0">
                                </td>
                                <td>
                                    <input v-model="item.discount_amount" @input="markTouched(index, 'discount_amount')" type="number" class="form-control text-center" :min="0">
                                </td>
                                <td>
                                    <input v-model="item.discount_percentage" @input="markTouched(index, 'discount_percentage')" type="number" class="form-control text-center" :min="0">
                                </td>
                                <td>
                                    <input v-model.trim="item.offer_start_date" @input="markTouched(index, 'offer_start_date')" type="date" class="form-control text-center">
                                </td>
                                <td>
                                    <input v-model.trim="item.offer_end_date" @input="markTouched(index, 'offer_end_date')" type="date" class="form-control text-center">
                                </td>
                                <td>
                                    <div :class="['status-dropdown', item.status.toLowerCase()]">
                                        <select v-model="item.status" @change="markTouched(index, 'status')" class="form-control text-center">
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="! items.length">
                                <td colspan="11" class="text-center empty-row">No endpoint products found under this group</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="modal-footer-bar text-center">
                    <button :disabled="loading || ! items.length" @click="handleSave" type="button" class="btn btn-primary me-1 waves-effect waves-float waves-light">
                        <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        Save
                    </button>
                    <button @click="toggleModal" class="btn btn-outline-secondary waves-effect">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, inject, watch, defineExpose } from 'vue'
import { useRoute } from 'vue-router'
import handlePurchase from '@/services/modules/purchase'
import handleContact from '@/services/modules/contact'
import useDate from '@/services/utils/day'
import AsyncSelect from '@/components/molecule/input-field/AsyncSelect.vue'
import { useAsyncDropdownHelper } from '@/services/utils/asyncDropdownHelper'

const props = defineProps({
    productGroups: {
        type: Array,
        default: () => []
    },
})

const emit = defineEmits(['onBulkSaved'])

const showError = inject('showError')
const showSuccess = inject('showSuccess')
const $route = useRoute()
const { currentDate } = useDate()
const { fetchSalesOfferGroupProducts, bulkStoreSalesOfferSetup } = handlePurchase()
const { fetchContactProfiles } = handleContact()
const { formatPatientLabel } = useAsyncDropdownHelper()

const companyId = $route.params.companyId
const isOpen = ref(false)
const loading = ref(false)
const groupId = ref(null)
const items = ref([])
const touched = ref({})
const globalContact = ref(null)
const customerQuery = ref({
    with_mobile: 1,
    with_donors: 1,
    dealer_id: '',
    roles: 'customer,lead'
})

const globalValues = reactive({
    min_order_qtn: '',
    slab_qtn: '',
    bonus_qty: '',
    discount_amount: '',
    discount_percentage: '',
    offer_start_date: '',
    offer_end_date: '',
    status: 'active',
})

const resetGlobalValues = () => {
    globalValues.min_order_qtn = ''
    globalValues.slab_qtn = ''
    globalValues.bonus_qty = ''
    globalValues.discount_amount = ''
    globalValues.discount_percentage = ''
    globalValues.offer_start_date = ''
    globalValues.offer_end_date = ''
    globalValues.status = 'active'
    globalContact.value = null
}

const markTouched = (index, field) => {
    if (! touched.value[index]) {
        touched.value[index] = {}
    }
    touched.value[index][field] = true
}

const isTouched = (index, field) => {
    if (! touched.value[index]) return false
    return !! touched.value[index][field]
}

const applyGlobalValue = (field) => {
    items.value.forEach((item, index) => {
        if (isTouched(index, field)) return
        item[field] = globalValues[field]
    })
}

const onContactSelected = (index) => {
    markTouched(index, 'customer')
    const selectedContact = items.value[index].customer
    items.value[index].contact_profile_id = selectedContact ? selectedContact.id : null
}

const applyGlobalContact = () => {
    items.value.forEach((item, index) => {
        if (isTouched(index, 'customer')) return
        item.customer = globalContact.value
        item.contact_profile_id = globalContact.value ? globalContact.value.id : null
    })
}

const loadGroupProducts = (id) => {
    if (! id) {
        items.value = []
        return
    }
    loading.value = true
    touched.value = {}
    resetGlobalValues()

    fetchSalesOfferGroupProducts(id, `?company_id=${companyId}`)
        .then((res) => {
            if (! res.status) {
                items.value = []
                return showError(res.message)
            }
            items.value = res.data.map((offer) => ({
                id: offer.id,
                product_id: offer.product_id,
                product_name: offer.product_name,
                contact_profile_id: offer.contact_profile_id,
                customer: offer.contact_profile_id ? {id: offer.contact_profile_id, name: offer.contact_profile_name} : null,
                unit_of_measurment: offer.unit_of_measurment || 'pcs',
                min_order_qtn: offer.min_order_qtn || 1,
                slab_qtn: offer.slab_qtn || 1,
                bonus_qty: offer.bonus_qty || 0,
                discount_amount: offer.discount_amount || 0,
                discount_percentage: offer.discount_percentage || 0,
                offer_start_date: offer.offer_start_date || currentDate(),
                offer_end_date: offer.offer_end_date || currentDate(),
                status: offer.status || 'active',
            }))
        })
        .catch(() => {
            items.value = []
            showError('Something is wrong. Check your connectivity!!')
        })
        .finally(() => {
            loading.value = false
        })
}

const handleSave = () => {
    if (! items.value.length) return
    loading.value = true

    const itemDetails = items.value.map((item) => ({
        id: item.id,
        product_id: item.product_id,
        contact_profile_id: item.contact_profile_id,
        unit_of_measurment: item.unit_of_measurment,
        min_order_qtn: item.min_order_qtn,
        slab_qtn: item.slab_qtn,
        bonus_qty: item.bonus_qty,
        discount_amount: item.discount_amount,
        discount_percentage: item.discount_percentage,
        offer_start_date: item.offer_start_date,
        offer_end_date: item.offer_end_date,
        status: item.status,
    }))

    bulkStoreSalesOfferSetup({
        company_id: companyId,
        product_head_id: groupId.value,
        item_details: itemDetails,
    })
        .then((res) => {
            if (! res.status) {
                return showError(res.message)
            }
            showSuccess(res.message)
            emit('onBulkSaved')
            toggleModal()
        })
        .catch(() => {
            showError('Something is wrong. Check your connectivity!!')
        })
        .finally(() => {
            loading.value = false
        })
}

const open = (group) => {
    isOpen.value = true
    if (groupId.value === group.id) {
        loadGroupProducts(group.id)
        return
    }
    groupId.value = group.id
}

const toggleModal = () => {
    isOpen.value = false
    groupId.value = null
    items.value = []
}

watch(groupId, (newGroupId) => {
    if (! isOpen.value) return
    loadGroupProducts(newGroupId)
})

defineExpose({ open, toggleModal })
</script>

<style scoped>
.group-offer-modal .modal-content {
    border: none;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
}

.modal-header-bar {
    background: #fafbfc;
    border-bottom: 1px solid #ececec;
}

.modal-title {
    font-size: 1.1rem;
    font-weight: 700;
    color: #2b2b2b;
    white-space: nowrap;
}

.group-select-field {
    width: 260px;
}

.offer-table-wrap {
    max-height: 68vh;
    padding: 0 1.25rem;
}

.offer-table {
    border-collapse: separate;
    border-spacing: 0;
    font-size: 0.88rem;
}

.offer-table thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #f4f6f9;
    color: #5b6270;
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    border: none;
    padding: 11px 10px;
    white-space: nowrap;
}

.offer-table tbody td {
    border: none;
    border-bottom: 1px solid #f0f1f4;
    padding: 6px 10px;
    vertical-align: middle;
}

.offer-table tbody tr:nth-child(even):not(.global-row) td {
    background-color: #fbfbfd;
}

.offer-table tbody tr:not(.global-row):hover td {
    background-color: #f5f4ff;
}

.offer-table .form-control {
    height: 34px;
    padding: 4px 10px;
    font-size: 0.86rem;
    border-radius: 7px;
    border: 1px solid #e2e5eb;
    transition: border-color .15s ease, box-shadow .15s ease;
}

.offer-table .form-control:focus {
    border-color: #7367f0;
    box-shadow: 0 0 0 3px rgba(115, 103, 240, 0.12);
}

.product-name {
    font-weight: 600;
    color: #2b2b2b;
}

.global-row td {
    background: linear-gradient(180deg, #f2f0fe, #ede9fd);
    border-bottom: 2px solid #d8d3fb;
    padding-top: 9px;
    padding-bottom: 9px;
}

.global-label {
    white-space: nowrap;
}

.global-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 12px;
    border-radius: 999px;
    background: #7367f0;
    color: #fff;
    font-size: 0.68rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    box-shadow: 0 2px 6px rgba(115, 103, 240, 0.35);
}

.global-badge::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #fff;
}

.status-dropdown {
    display: inline-block;
    border-radius: 15px;
    font-weight: 600;
    text-align: center;
    min-width: 92px;
}

.status-dropdown select {
    background: transparent;
    border: none;
    color: inherit;
    font-weight: inherit;
    padding: 5px 8px;
    width: 100%;
    appearance: none;
}

.status-dropdown.active {
    background-color: #d4f7dc;
    color: #28a745;
}

.status-dropdown.inactive {
    background-color: #f7d4d4;
    color: #dc3545;
}

.empty-row {
    padding: 3rem 0;
    color: #9aa0ac;
    font-size: 0.95rem;
}

.modal-footer-bar {
    background: #fff;
    border-top: 1px solid #ececec;
    padding: 1rem 1.25rem;
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.04);
    position: relative;
    z-index: 3;
}
</style>
